import styled from "styled-components";
import { UiConstants } from "../../data/UiConstants";
export const ListItem = styled.div.withConfig({
  displayName: "ListItem",
  componentId: "sc-lnqlzs-0"
})(["display:block;background-color:white;width:calc(100% - 6px);margin:1px;padding:6px;text-align:left;cursor:pointer;border-radius:", ";border:solid 2px white;&:hover{background-color:", ";}&.selected{margin:1px;border:solid 2px black;color:white;background-color:", ";}"], UiConstants.BORDER_RADIUS, UiConstants.COLOR_HOVER, UiConstants.COLOR_SELECTION_HIGHLIGHT);
export const ListItemNoWrapping = styled(ListItem).withConfig({
  displayName: "ListItem__ListItemNoWrapping",
  componentId: "sc-lnqlzs-1"
})(["white-space:nowrap;"]);